    let tags = document.querySelectorAll('.meta-info-block');
    let bg = document.querySelector( '.overlay-background');

    for ( const tag of tags) {
        const overlay = tag?.querySelector('.meta-info-overlay');
        const overlay_header = overlay?.querySelector('.overlay-header') || 0;
        const overlay_content = overlay_header?.nextElementSibling || null;
        if(overlay_content) overlay_content.style.height = `calc(100dvh - ${overlay_header?.offsetHeight}px)`;
        if(overlay_content) overlay_content.style.overflowY = 'auto';
        const close_btn = overlay?.querySelector('.close-btn');
        tag.addEventListener( 'click', () => {
            overlay?.classList.add('active');
            document.querySelector('body')?.classList?.add('meta-info-overflow');
            document.querySelector('html')?.classList?.add('meta-info-overflow');
            bg?.classList.add( 'active' );
        });
        close_btn?.addEventListener('click', ( e ) => {
            e.stopPropagation();
            overlay?.classList.remove('active');
            bg?.classList.remove( 'active' );
            document.querySelector('body')?.classList?.remove('meta-info-overflow');
            document.querySelector('html')?.classList?.remove('meta-info-overflow');
        });
        bg?.addEventListener('click', () => {
            overlay?.classList.remove('active');
            bg.classList.remove( 'active' );
            document.querySelector('body')?.classList?.remove('meta-info-overflow');
            document.querySelector('html')?.classList?.remove('meta-info-overflow');
        });
    }


    const engravingContainer = document.querySelector('.engraving');
    const button = engravingContainer?.querySelector('.btn');
    const text = engravingContainer?.querySelector('#custom-engraving');
    const btn_text = button?.innerHTML;
    const maxLength = text?.getAttribute('maxlength');

    button?.addEventListener( 'click', () => {

        text?.classList.toggle('hide');
        text?.classList.toggle('open');
        button.classList.toggle('open');

        if(button.classList.contains('open')) {
            button.innerHTML = `
              <div>
                <span>${maxLength} characters remaining</span>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>  
              </div>
        `;

            const textLength = text?.value.replace( ' ', '').length;
            if( textLength === 0 ) {
                engravingContainer?.nextElementSibling.setAttribute('disabled', 'disabled');
            } else {
                engravingContainer?.nextElementSibling.removeAttribute('disabled');
            }

        } else {
            engravingContainer?.nextElementSibling?.removeAttribute('disabled');
            button.innerHTML = btn_text;
            text.value = '';
        }
    });



    text?.addEventListener( 'input', () => {
        const textLength = text.value.length;
        const counter = button?.querySelector('span');
        counter ? counter.innerHTML = `${ maxLength - textLength } characters remaining`: null;
        if( textLength === 0 ) {
            engravingContainer?.nextElementSibling?.setAttribute('disabled', 'disabled');
        } else {
            engravingContainer?.nextElementSibling?.removeAttribute('disabled');
        }
    });



